'use client';
import { FC, useState } from 'react';
import { useSettingsContext } from '@/contexts/SettingsContext';

interface Props {
    onTabClick: () => void;
}

const GroupTabs: FC<Props> = ({ onTabClick }) => {
    const [activeLeftTab, setActiveLeftTab] = useState(true);

    const { getLabel } = useSettingsContext();
    const COLINSON_GROUP_BOARD_LABEL = getLabel('label', 'collinsonGroupBoard');
    const COLINSON_GROUP_COMPANIES_LABEL = getLabel('label', 'collinsonGroupCompanies');
    const toggleTab = () => {
        setActiveLeftTab((prevState) => !prevState);
        onTabClick();
    };
    return (
        <div className="tw-hidden  md:tw-flex  tw-w-[556px] tw-h-[39px] tw-mx-auto tw-bg-[#4B4F540D] tw-text-[#003865] tw-text-1 tw-rounded-3xl tw-font-gotham tw-font-medium hover:tw-text-[#ce0058]">
            <div
                onClick={toggleTab}
                className={`tw-flex tw-justify-center tw-text-[16px] tw-items-center tw-w-1/2 tw-h-[39px] tw-rounded-3xl ${activeLeftTab ? 'tw-bg-[#ce0058] tw-text-white ' : 'hover:tw-text-[#ce0058]'} tw-transition-all tw-duration-900 tw-cursor-pointer`}
            >
                {COLINSON_GROUP_BOARD_LABEL}
            </div>
            <div
                onClick={toggleTab}
                className={`tw-flex tw-justify-center tw-text-[16px] tw-items-center tw-w-1/2 tw-h-[39px] tw-rounded-3xl ${!activeLeftTab ? 'tw-bg-[#ce0058] tw-text-white' : 'tw-hover:text-[#ce0058]'} tw-transition-all tw-duration-900 tw-cursor-pointer`}
            >
                {COLINSON_GROUP_COMPANIES_LABEL}
            </div>
        </div>
    );
};

export default GroupTabs;
